import CmsFlexBox from '../Models/CMS/CmsFlexBox';
import dayjs from 'dayjs';

import { ApiBooking } from '@ibe/api';
import { PlaceholderUtils } from './PlaceholderUtils';

abstract class FlexBoxUtils {
  public static getFlexBoxes(
    flexBoxes: CmsFlexBox[],
    position: string,
    page?: string
  ): CmsFlexBox[] {
    let pageFlexBoxes;

    if (page) {
      pageFlexBoxes = flexBoxes.filter(flexBox => flexBox.page === page);
    } else {
      pageFlexBoxes = flexBoxes.filter(flexBox => !flexBox.page);
    }
    return pageFlexBoxes.filter(flexBox => flexBox.position === position);
  }

  public static getDefaultFlexBox(flexBoxes: CmsFlexBox[]): CmsFlexBox | undefined {
    return flexBoxes.find(flexBox => !flexBox.dateTo && !flexBox.dateFrom);
  }

  public static getDatedFlexBox(
    flexBoxes: CmsFlexBox[],
    searchStart: string
  ): CmsFlexBox | undefined {
    return flexBoxes.find(flexBox => {
      if (flexBox.dateFrom && flexBox.dateTo) {
        const dateFrom = dayjs(flexBox.dateFrom);
        const dateTo = dayjs(flexBox.dateTo);
        const searchStartDate = dayjs(searchStart);

        if (
          (searchStartDate.isBefore(dateTo) || searchStartDate.isSame(dateTo, 'day')) &&
          (searchStartDate.isAfter(dateFrom) || searchStartDate.isSame(dateFrom, 'day'))
        ) {
          return flexBox;
        }
      }
    });
  }

  public static transformOSSPFlexBoxes(
    booking: ApiBooking,
    flexBoxes: CmsFlexBox[],
    dateFormat: string
  ): CmsFlexBox[] {
    const resultingFlexBoxes: CmsFlexBox[] = [];

    if (flexBoxes) {
      flexBoxes.forEach(flexBox =>
        resultingFlexBoxes.push({
          page: flexBox.page,
          position: flexBox.position,
          header: flexBox.header,
          dateFrom: flexBox.dateFrom,
          dateTo: flexBox.dateTo,
          initiallyExpanded: flexBox.initiallyExpanded,
          content: PlaceholderUtils.map(booking, flexBox.content ?? '', dateFormat)
        })
      );
    }

    return resultingFlexBoxes;
  }
}

export default FlexBoxUtils;
